import React from "react";
import { getApiUrl, getRelativeUrl } from "../../utils/urlHelper";

const ParticipantsTab = ({
  participants,
  handleTogglePermission,
  handleRemoveUserFromGroup,
}) => {
  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <div className="settings-card-icon">👥</div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <h2 className="settings-card-title">
            Participants & Access ({participants.length})
          </h2>
          <span
            style={{
              fontSize: "12px",
              background: "#e0e7ff",
              color: "#4338ca",
              padding: "4px 12px",
              borderRadius: "12px",
              fontWeight: 700,
            }}
          >
            {participants.length} Active User{participants.length !== 1 ? "s" : ""}
          </span>
        </div>
      </div>

      {participants.length > 0 ? (
        <div className="participant-list-container">
          <div
            style={{
              background: "#faf5ff",
              border: "1px solid #e9d5ff",
              padding: "12px 16px",
              borderRadius: "12px",
              marginBottom: "16px",
            }}
          >
            <strong style={{ color: "#6b21a8", fontSize: "13px" }}>
              👑 Manage Group Admins & Permissions
            </strong>
            <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#6b7280" }}>
              Group Admins get full access to view all photos & download all
              photos (Upload/Delete rights remain restricted to Main Owner).
            </p>
          </div>

          {participants.map((userItem, idx) => {
            const name = userItem.name || "User";
            const email = userItem.email || "No email provided";
            const initial = name[0].toUpperCase();

            return (
              <div key={userItem._id || idx} className="participant-item-card">
                <div className="participant-info-left">
                  {userItem.profileImage ? (
                    <img
                      src={getApiUrl(getRelativeUrl(userItem.profileImage))}
                      alt={name}
                      className="participant-avatar"
                    />
                  ) : (
                    <div className="participant-avatar">{initial}</div>
                  )}
                  <div className="participant-details">
                    <span className="participant-name">{name}</span>
                    <span className="participant-email">{email}</span>
                  </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <span
                    className={`participant-badge ${
                      userItem.isOwner
                        ? "owner"
                        : userItem.isPermitted
                        ? "admin"
                        : "member"
                    }`}
                    style={{
                      padding: "4px 10px",
                      borderRadius: "12px",
                      fontSize: "11px",
                      fontWeight: 700,
                      background: userItem.isOwner
                        ? "#fef3c7"
                        : userItem.isPermitted
                        ? "#e0e7ff"
                        : "#f1f5f9",
                      color: userItem.isOwner
                        ? "#d97706"
                        : userItem.isPermitted
                        ? "#4338ca"
                        : "#64748b",
                      border: userItem.isOwner
                        ? "1px solid #fde68a"
                        : userItem.isPermitted
                        ? "1px solid #c7d2fe"
                        : "1px solid #e2e8f0",
                    }}
                  >
                    {userItem.isOwner
                      ? "👑 Main Owner"
                      : userItem.isPermitted
                      ? "⭐ Group Admin (Full Access)"
                      : "👤 Member"}
                  </span>

                  {!userItem.isOwner && (
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <button
                        type="button"
                        onClick={() => handleTogglePermission(userItem._id)}
                        title={
                          userItem.isPermitted
                            ? "Demote to Normal Member (View own photos only)"
                            : "Make Group Admin (Full access to all photos)"
                        }
                        style={{
                          background: userItem.isPermitted ? "#fff7ed" : "#dcfce7",
                          color: userItem.isPermitted ? "#c2410c" : "#166534",
                          border: userItem.isPermitted
                            ? "1px solid #ffedd5"
                            : "1px solid #86efac",
                          padding: "6px 12px",
                          borderRadius: "8px",
                          fontSize: "12px",
                          fontWeight: 600,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                      >
                        {userItem.isPermitted
                          ? "↩ Demote to Member"
                          : "⭐ Make Group Admin"}
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          handleRemoveUserFromGroup(userItem._id, name)
                        }
                        title="Remove user from this group completely"
                        style={{
                          background: "#fee2e2",
                          color: "#dc2626",
                          border: "1px solid #fca5a5",
                          padding: "6px 12px",
                          borderRadius: "8px",
                          fontSize: "12px",
                          fontWeight: 600,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                      >
                        🗑️ Remove from Group
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "20px",
            color: "#64748b",
            fontSize: "14px",
          }}
        >
          No external participants have joined this group yet.
        </div>
      )}
    </div>
  );
};

export default ParticipantsTab;
